<template>
  <div id="dashboard">
    <!-- <div data-html2canvas-ignore="true" class="customdim"
      v-show="loader0 || loader || loader1 || loader2 || loader3 || loader4 || loader5 || loader6 || loader7 || loader8">
      <div class="spinner-border" role="status"></div>
      <span class="sr-only">Loading...</span>
    </div> -->
    <div data-html2canvas-ignore="true"
      v-show="loader0 || loader || loader1 || loader2 || loader3 || loader4 || loader5 || loader6 || loader7 || loader8">
      <Loader />
      <!-- <div class="spinner-border" role="status"></div>
      <span class="sr-only">Loading...</span> -->
    </div>
    <!-- india map and trendline start  -->
    <div class="card revampCard">
      <div style="display: flex; width: 100%;" class="flex-wrap">
        <div class="mr-2">
          <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Date Range</div>
          <date-range-picker v-model="dateRange" opens='right' :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }" :show-dropdowns="true" :min-date="minDate" :max-date="maxDate">
          </date-range-picker>
        </div>
        <div class="customSelect mr-2 dropdown-width" v-if="viewPlatformList.length">
          <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Platform</div>
          <select class="form-control text-uppercase" v-model="selectedTrendLinePlatform">

            <option v-for="(option, i) in viewPlatformList" :key="option" :value="option">
              {{ option.replaceAll("_", " ") }}
            </option>
          </select>
        </div>
        <div class="customSelect dropdown-width" v-if="viewSegmentData.length">
          <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Category</div>
          <select class="form-control text-uppercase" v-model="selectedSegementForTrendline">
            <option value="all">All Categories</option>
            <option v-for="(option, i) in viewSegmentData" :key="option + i + 'sp'" :value="option">
              {{ option.replaceAll("_", " ") }}
            </option>
          </select>
        </div>
        <div>
          <button @click="filterApply" class="btn primarycolor ml-3" style="margin-top:1.4rem">
            Apply Filters
          </button>
        </div>


        <!-- <div class="custom_dropdown customMultiselect" style="max-width:40%">
            <multiselect
              v-model="selectedProductListForTrendline"
              :options="viewProductList"
              :multiple="true"
              placeholder="Search Product"
              select-label=""
              deselect-label=""
              selectedLabel=""
              :closeOnSelect="false"
              @select="changeProductName($event)"
              @remove="changeProductName($event)"
            >
              <template slot="option" slot-scope="{ option }">
                <div v-if="option.$isLabel">
                  <strong>{{ option.$groupLabel }}</strong>
                </div>
                <div v-else>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedProductListForTrendline"
                  />
                  <span class="option__title ml-3">{{ option }}</span>
                </div>
              </template>
</multiselect>
</div> -->

        <!-- <div class="lastUpdated">
          Last Updated: {{ lastUpdated }}
        </div> -->
      </div>
    </div>
    <div class="row revampCard pb-0 card-deck">
      <div class="col-12 col-lg-6 mb-3 mb-lg-0 card mr-0 mr-lg-2 ml-0 ml-lg-1" style="border:none">
        <div class=" mb-0" v-if="procesedPieChartData.length">
          <h5 class="borderBottom graphHeading pb-3" style="margin-bottom: 5px !important">
            {{ tempSelectedTrendLinePlatform.replaceAll("_", " ") }}
          </h5>
          <pieChart :data="procesedPieChartData" />
        </div>
        <div class="" style="border:none" v-else>
          <div class=" text-danger d-flex justify-content-center border border-danger rounded p-2">No Data!</div>
        </div>
      </div>

      <div class="col-12 col-lg-6 card mr-0 ml-0" style="border:none">
        <div class=" mb-0" v-if="procedIndiaMapData.length">
          <div>
            <h5 class="borderBottom pb-3 graphHeading" style="margin-bottom: 5px !important">
              {{ tempSelectedTrendLinePlatform.replaceAll("_", " ") }}
            </h5>
            <div class="d-flex justify-content-end">
              <!-- <div class="mr-3">Availability % :</div> -->
              <span class="mr-3">
                <i class="fa fa-circle" style="color: rgba(173, 247, 182, 1)"></i> >= 90%
              </span>
              <span class="mr-3">
                <i class="fa fa-circle" style="color: rgba(194, 195, 255, 1)"></i>
                < 90% </span>
                  <span class="mr-3">
                    <i class="fa fa-circle" style="color: rgba(255, 242, 194, 1)"></i>
                    <= 70% </span>
                      <span class="mr-3">
                        <i class="fa fa-circle" style="color: rgba(255, 211, 211, 1)"></i>
                        <= 20% </span>
            </div>
          </div>
          <indiaMap :data="procedIndiaMapData" />
        </div>
        <div class="" style="border:none" v-else>
          <div class=" text-danger d-flex justify-content-center border border-danger rounded p-2">No Data!</div>
        </div>
      </div>
    </div>
    <div class="row revampCard pb-0 ">
      <div class="col-12 card mr-0 ml-0 mb-0" style="border:none">
        <div class=" mb-0" v-if="procedTrandLineData.xAxis.length">
          <div class="d-flex justify-content-between borderBottom">
            <h4 class="graphHeading " style="margin-bottom: 0px !important">
              Availability Trend
            </h4>
            <div class="col-md-2 px-0 customMultiselect mb-2" v-if="Object.keys(viewPinListTrendLine).length">
              <!-- <multiselect v-model="selectedPinForTrendLine" :options="viewPinListTrendLine" :multiple="true"
                group-values="pins" group-label="City" :group-select="true" placeholder="Select PIN(s)" track-by="pin"
                label="pin" selectGroupLabel="Select group" deselectGroupLabel="Deselect group" selectLabel="Select"
                deselectLabel="Remove" @input="getTrendlineGraphData()"><span slot="noResult">Oops! No elements found.
                  Consider changing the search query.</span></multiselect> -->
              <treeselect v-model="selectedPinForTrendLine" :options="viewPinListTrendLine"
                value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="false" placeholder="Select PIN(s)"
                :multiple="true" @input="getTrendlineGraphData()" :searchable="true">
                <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
              </treeselect>
            </div>
          </div>
          <lineChart :data="procedTrandLineData" />
        </div>
        <div v-else class=" text-danger d-flex justify-content-center border border-danger rounded p-2">No Data!</div>
      </div>
    </div>
    <!-- india map and trendlind end -->
    <div class="card revampCard d-flex flex-col flex-lg-row justify-content-between">
      <div class="d-flex  flex-wrap">
        <!-- <div class="mr-2">
          <datepicker placeholder="Select Date" @input="dateChange" v-model="date" />
        </div> -->
        <div class="mr-2">
          <div class="mb-1 ml-2" style="font-size:14px; font-weight:400; color:#1E1E1E">Date</div>
          <date-range-picker style="width: 150px;" v-model="date" :show-dropdowns="true" opens='right' :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate" :single-date-picker="true"
            :ranges="false" @update="handleDateChange">
          </date-range-picker>
        </div>
        <div class="datebox customSelect dropdown-width" v-if="segmentDropdown.isSegment">
          <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Category</div>
          <select class="form-control text-uppercase" v-model="segmentDropdown.selectedSegment"
            @change="filterProcutListForAvailMetricTable(true)">
            <option value="">All Categories</option>
            <option v-for="option in segmentDropdown.options" :key="option + 'modal'" :value="option">
              {{ option.replaceAll("_", " ") }}
            </option>
          </select>
        </div>
        <div class="mr-2 customMultiselect" style="width: 13rem;;"
          v-if="segmentDropdown.isSegment">
          <div class="custom_dropdown customMultiselect">
            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Product</div>
            <multiselect v-model="segmentDropdown.selectedProduct" :options="segmentDropdown.productFilterList"
              :multiple="false" placeholder="Search Product" select-label="" deselect-label="" selectedLabel=""
              :closeOnSelect="true">
            </multiselect>
          </div>
          <!-- <multiselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options" :multiple="true"
            group-values="pins" group-label="City" :group-select="true" placeholder="Select PIN(s)" track-by="pin"
            label="pin" selectGroupLabel="Select group" deselectGroupLabel="Deselect group" selectLabel="Select"
            deselectLabel="Remove" @input="processSelectedPin()">
            <span slot="noResult">Oops! No
              elements found. Consider changing the search query.</span>
            </multiselect> -->
        </div>
        <div class="customMultiselect" style="width: 12rem;"
          v-if="locationDropdown.options.length">
          <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Pincode</div>
          <treeselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options"
            value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="false" placeholder="Select PIN(s)" :multiple="true"
            :searchable="true">
            <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
          </treeselect>
          <!-- <multiselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options" :multiple="true"
            group-values="pins" group-label="City" :group-select="true" placeholder="Select PIN(s)" track-by="pin"
            label="pin" selectGroupLabel="Select group" deselectGroupLabel="Deselect group" selectLabel="Select"
            deselectLabel="Remove" @input="processSelectedPin()">
            <span slot="noResult">Oops! No
              elements found. Consider changing the search query.</span>
            </multiselect> -->
        </div>
        <button @click="handleExportFilter" class="btn exportButton mt-4 mr-2 px-3">
          Apply Filters
        </button>
        <div class="d-lg-none" v-if="client === 'india_gate'">
          <button class="exportButton dropdown-toggle" type="button" ref="clrBtn" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">
            Export
          </button>
          <div class="CustomDropdown" v-if="isDropdown">
            <div class="customItem" @click="downloadExel">Export top 20 products</div>
            <div class="customItem" @click="downloadLastExel">Export last 2 months</div>
          </div>
        </div>
        <div class="d-lg-none" v-else style="display:flex ; justify-content:end">
          <button @click="downloadStandardExel" class="ui button exportButton ml-1 mt-4">Export</button>

          <!-- <button @click="downloadLastExel" class="ui button exportButton ml-1">Export last 2 months</button> -->
        </div>
      </div>

      <div class="d-none d-lg-block" v-if="client === 'india_gate'">
        <button class="exportButton dropdown-toggle" type="button" ref="clrBtn" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">
          Export
        </button>
        <div class="CustomDropdown" v-if="isDropdown">
          <div class="customItem" @click="downloadExel">Export top 20 products</div>
          <div class="customItem" @click="downloadLastExel">Export last 2 months</div>
        </div>
      </div>
      <div class="d-none d-lg-block"  v-else style="display:flex ; justify-content:end">
        <button @click="downloadStandardExel" class="ui button exportButton ml-1 mt-4">Export</button>

        <!-- <button @click="downloadLastExel" class="ui button exportButton ml-1">Export last 2 months</button> -->
      </div>
    </div>
    <div class="card p-2 revampCard">
      <div>
        <!-- <div class="d-flex justify-content-end mb-2"> -->
        <!-- <div class="mr-3">Availability % :</div> -->

        <!-- <span class="mr-3">
            <i class="fa fa-circle" style="color: #c8d6cd"></i> > 90%
          </span>
          <span class="mr-3">
            <i class="fa fa-circle" style="color: yellow"></i>
            < 90% </span>
              <span class="mr-3">
                <i class="fa fa-circle" style="color: #b2bdff"></i>
                < 70% </span>
                  <span class="mr-3">
                    <i class="fa fa-circle" style="color: #ffbeb5"></i>
                    < 20% </span> -->
        <!-- </div> -->
        <div v-if="mainTableData.data.length">
          <table id="indiagate-dashboard-table" v-if="mainTableData.data.length" class="table mt-1">
            <thead>
              <tr>
                <th v-for="(head, idx) in mainTableData.header" :key="head.key">
                  <img v-if="head.img" style="width: 19px" :src="head.img" />
                  {{ head.value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in mainTableData.data" :key="row.link">
                <td v-for="(col, idx) in mainTableData.header" :key="col.key" :style="[
                  row.platform[col.key] && {
                    background: colorMapping[row.platform[col.key].color],
                  },
                ]">
                  <div v-if="col.key == 'product_name'">
                    <span class="text-capitalize">{{ row.name }}</span>
                  </div>
                  <div v-if="col.key == 'segment'" style="padding: 4px">
                    <span class="text-capitalize" code>{{ row.segment.replaceAll("_", " ") }}</span>
                  </div>
                  <div class="d-flex justify-content-between" style="padding: 4px" v-if="row.platform[col.key]">
                    <!-- <div>
                    <div class="info_mrp">MRP: {{ row.platform[col.key].mrp }}</div>
                    <div class="info_price">Price: {{ row.platform[col.key].offer }}</div>
                  </div> -->
                    <div class="align-items-start" style="z-index: 10">
                      <div @click="processModal(row.platform[col.key].location, row.name, 1)" class="avail_modal_cta">
                        Available on : {{ row.platform[col.key].total_available }} pincodes
                      </div>
                      <div @click="processModal(row.platform[col.key].location, row.name, 0)" class="unavail_modal_cta">
                        Unavailable on : {{ row.platform[col.key].total_unavailable }} pincodes
                      </div>
                    </div>

                    <div class="d-flex">
                      <div @click="processTrendLineModal(col.key, row.segment, row.name)" class="icon mr-2"><i
                          class="fa fa-line-chart"></i></div>
                      <a :href="row.platform[col.key].link" class="icon" target="_blank" rel="noopener noreferrer"><i
                          class="fa fa-external-link"></i></a>
                    </div>
                  </div>
                  <div v-else style="display: flex; justify-content: center; align-items: center">
                    <div v-show="!(col.key == 'product_name' || col.key == 'segment')">
                      N/A
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-danger d-flex justify-content-center border border-danger rounded p-2">No Data!</div>
      </div>
    </div>
    <b-modal size="lg" class="customModal" id="trendLineModal" hide-footer :title="modalData.heading"
      v-model="showModal">
      <div class="alert alert-danger p-3" v-if="!modalData.tableData.length" role="alert">
        No Data!!
      </div>
      <div v-else class="p-2" id="#modalContainer">
        <table id="modalTable" class="table">
          <thead>
            <tr>
              <th v-for="(head, idx) in modalData.tableHeader" :key="head + idx">{{ head.value }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in modalData.tableData" :key="row.location_name + i">
              <td>{{ row.location_name }}</td>
              <td>
                <div>
                  <b-badge class="mr-2 p-1" style="font-size: 12px; cursor: copy;" v-for="code in row.data"
                    :key="code.pincode" variant="light" @click="copyToClipboard(code.pincode)"><i
                      class="fa fa-circle mr-1 mt-1" :style="[
                        code.available == 1
                          ? { color: 'var(--green)' }
                          : { color: 'var(--red)' },
                      ]"></i>{{ code.pincode }}</b-badge>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal size="xl" class="customModal" id="trendLineModal" hide-footer
      style="z-index: 3000 !important; text-transform: capitalize" :title="selectedProductTrendlineModal"
      v-model="showTrendLineModal">
      <!-- <div class="alert alert-danger p-3"  role="alert">
        No Data!!
      </div> -->
      <div class="p-2 w-100" id="#modalContainer" v-if="procedModalTrandLineData.xAxis">
        <div style="display: flex; width: 100%" class="flex-wrap">
          <div class="mr-2 ml-lg-2">
            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Date Range</div>
            <date-range-picker v-model="trendlineModalDateRange" opens='right' :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate"
              @update="dateChangeModalTrendLine">
            </date-range-picker>
          </div>
          <div style="width: 18rem" class="datebox customSeflect" v-if="platformList">
            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Platform</div>
            <select class="form-control text-uppercase" v-model="selectedPlatformTrendlineModal"
              @change="processSegmentModalData(false)">
              <option v-for="(option, i) in viewPlatformList" :key="option + i + 'p2'" :value="option">
                {{ option.replaceAll("_", " ") }}
              </option>
            </select>
          </div>
          <div style="width: 7rem" class="datebox customSelect" v-if="platformList">
            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Category</div>
            <select class="form-control text-uppercase" v-model="selectedSegmentTrendlineModal"
              @change="processModalProductListOfSegment()">
              <option value="all">All</option>
              <option v-for="(option, i) in viewModalSegmentData" :key="option + i + 'sp2'" :value="option">
                {{ option.replaceAll("_", " ") }}
              </option>
            </select>
          </div>
          <div class="custom_dropdown customMultiselect" style="width: 15rem;">
            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Product</div>
            <multiselect v-model="selectedProductTrendlineModal" :options="viewModalProductList" :multiple="false"
              placeholder="Search Product" select-label="" deselect-label="" selectedLabel="" :closeOnSelect="true"
              @input="getModalTrendlineGraphData()">
            </multiselect>
          </div>
          <div class=" ml-2 customMultiselect" style="width:10rem" v-if="viewPinListModalTrendLine">
            <!-- <multiselect v-model="selectedPinTrendLineModal" :options="viewPinListModalTrendLine" :multiple="true"
              group-values="pins" group-label="City" :group-select="true" placeholder="Type pin" track-by="pin"
              label="pin" selectGroupLabel="Press enter to select city" @input="getModalTrendlineGraphData()"><span
                slot="noResult">Oops! No elements found. Consider changing the search query.</span></multiselect> -->
            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Pincode</div>
            <treeselect v-model="selectedPinTrendLineModal" :options="viewPinListModalTrendLine"
              value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="false" placeholder="Select PIN(s)"
              :multiple="true" @input="getModalTrendlineGraphData()" :searchable="true">
              <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </treeselect>
          </div>
        </div>
        <div v-if="procedModalTrandLineData.xAxis.length" class="mt-2">
          <lineChart :data="procedModalTrandLineData" :chartId="selectedSegmentTrendlineModal" />
        </div>
        <div v-else class=" mt-2 text-danger d-flex justify-content-center border border-danger rounded p-2">No Data!
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import pinList from "./pinList.json";
import lineChart from "../commonCharts/lineChart.vue";
import indiaMap from "../commonCharts/IndiaMap.vue";
import pieChart from "../commonCharts/pieChart.vue";
import StateMapper from '../commonCharts/IndiaState.json'
import { all } from "q";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Loader from "../Components/Loader.vue";

export default {
  name: "indiagateDashboard",
  components: {
    Datepicker,
    Multiselect,
    lineChart, indiaMap, pieChart, Treeselect, Loader
  },
  data: function () {
    return {
      loader0: false,
      loader: false,
      loader1: false,
      loader2: false,
      loader3: false,
      loader4: false,
      loader5: false,
      loader6: false,
      loader7: false,
      loader8: false,
      showModal: false,
      dateRange: {
        startDate: moment().subtract(1, 'weeks').format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, 'month')),
      trendlineModalDateRange: {
        startDate: moment().subtract(1, 'weeks').format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      client: JSON.parse(localStorage.reviewUserData).data.client,
      isExportButton: JSON.parse(localStorage.reviewUserData).data.is_excel,
      // date: new Date(moment().subtract(1, "day")),
      date: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      locationDropdown: {
        options: '',
        checkSelectedPins: [],
        selectedPin: [],
      },
      segmentDropdown: {
        options: '',
        selectedSegment: "",
        isSegment: '',
        selectedProduct: '',
        productList: '',
        productFilterList: []
      },
      mainTableData: {
        header: [
          { key: "product_name", value: "Product Name" },
          { key: "amazon", value: "Amazon" },
          { key: "flipkart", value: "Flipkart" },
        ],
        data: [],
      },
      modalData: {
        heading: "",
        tableHeader: [
          { key: "location", value: "Location" },
          { key: "pincode", value: "Pincodes" },
        ],
        tableData: [
          { location: "Delhi", pincode: ["110059", "110071", "110067"] },
          { location: "Noida", pincode: ["56656", "54546", "12354"] },
        ],
      },
      colorMapping: {
        red: "rgba(255, 211, 211, 1)",
        yellow: "rgba(255, 242, 194, 1)",
        green: "#CAFFD1",
        blue: "rgba(194, 195, 255, 1)",
      },
      isDropdown: false,
      isSelectedSegment: true,
      viewProductList: [],
      platformList: ['Amazon', 'Flipkart'],
      viewTrendLineData: '',
      procedTrandLineData: { xAxis: [] },
      viewSegmentPlatformAndProductData: '',
      viewPlatformList: '',
      viewSegmentData: '',
      viewProductList: '',
      selectedTrendLinePlatform: '',
      tempSelectedTrendLinePlatform: '',
      selectedSegementForTrendline: 'all',
      selectedProductListForTrendline: '',
      viewIndiaMapData: '',
      procedIndiaMapData: [],
      indiaStateMapper: StateMapper,
      showTrendLineModal: false,
      viewPieChartData: '',
      procesedPieChartData: '',
      viewPinListTrendLine: '',
      selectedPinForTrendLine: [],

      // Trend line modal section start 
      viewModalSegmentData: '',
      viewModalProductList: '',
      viewModalTrendLineData: '',
      viewPinListModalTrendLine: '',
      procedModalTrandLineData: { xAxis: [] },
      selectedPlatformTrendlineModal: '',
      selectedSegmentTrendlineModal: 'all',
      selectedProductTrendlineModal: '',
      selectedPinTrendLineModal: [],
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      // Trend line modal section end 

    };
  },
  created() {
    window.addEventListener("click", this.close)
  },
  beforeDestroy() {
    window.removeEventListener("click", this.close)
  },
  mounted() {
    // this.init();
    this.getSegmentListData();
    this.getLastUpdatedDates()
  },
  methods: {
    copyToClipboard(value) {
      window.navigator.clipboard.writeText(value);
      this.$bvToast.toast(`Copied ${value} to clipboard`, {
        title: "Weavr Sense",
        variant: "success",
        toaster: "b-toaster-top-right",
        autoHideDelay: 3000
      });
    },
    init() {
      this.formatDates();
      this.getSegmentListData();
      this.getPinListData();
      this.getPinListForTrendLine();
      this.getTableData();
      this.getSegmentWiseProductListData();
      // this.getStateWiseData();
      // this.getPieChartData();
    },
    toggleDropdown() {
      if (this.isDropdown) {
        this.isDropdown = false
      }
      else {
        this.isDropdown = true
      }
    },
    handleDateChange() {
      this.getPinListData();
    },
    filterApply() {
      this.tempSelectedTrendLinePlatform = this.selectedTrendLinePlatform
      this.dateChangeTrendLineAndMap()
      this.processSegmentData()
      this.processProductListOfSegment()
    },
    handleExportFilter() {
      this.isSelectedSegment = false;
      this.processSelectedPin();
      this.formatDates();
    },
    close(event) {
      if (event.target) {
        //prevent closing the box when clear search button is clicked
        if (event.target == this.$refs.clrBtn) { return; }
        else this.isDropdown = false
      }
    },
    getLastUpdatedDates() {
      this.loader0 = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}`;
      this.$http.get(url).then(
        (response) => {
          // console.log(response.body.data.data.availability_matrix, 'ddd')
          if (response.body.data.availability_matrix) {
            localStorage.availability_matrix_last_update = JSON.stringify(response.body.data.availability_matrix);
            this.dateRange.endDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(response.body.data.availability_matrix.end_date).subtract(1, 'week').format("YYYY-MM-DD");
            // console.log(response.body, 'ddd')
            this.date.startDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
            this.date.endDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
            this.trendlineModalDateRange.startDate = moment(response.body.data.availability_matrix.end_date).subtract(1, 'week').format("YYYY-MM-DD");
            this.trendlineModalDateRange.endDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
            this.maxDate = new Date(response.body.data.availability_matrix.end_date);
            this.minDate = new Date(response.body.data.availability_matrix.start_date);
            this.lastUpdated = `${moment(response.body.data.availability_matrix.end_date).format("DD MMM, YYYY")} ${response.body.data.availability_matrix.latest_time?"at":""} ${response.body.data.availability_matrix.latest_time}`;
            this.$store.dispatch('DemoStore/setTimeStamp', this.lastUpdated);
           }
          this.loader0 = false;
          this.init();
        },
        (err) => {
          this.loader0 = false;
          this.init();
          console.log("err");
        }
      );
    },
    downloadStandardExel() {
      let self = this;
      this.loader = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
        pincode: this.locationDropdown.selectedPin,
      };
      const url = "/api/v2/indian_clients/pincode/availability_matrix_report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    downloadExel() {
      let self = this;
      this.loader = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
      };
      const url = "/api/v2/india_clients/pincode_report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    downloadLastExel() {
      let self = this;
      this.loader = true;
      let endData = moment().subtract(1, 'days').format("YYYY-MM-DD")
      let payload = {
        start_date: moment(endData).subtract(2, 'months').format("YYYY-MM-DD"),
        end_date: endData,
        client: this.client
      };
      if (this.isSegment) {
        payload.segment = []
      }
      const url = "/api/v2/india_client/pincode_avaimonth_report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    formatDates() {
      this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
      this.date.endDate = moment(this.date.endDate).format("YYYY-MM-DD");
      // this.dateRange.startDate = moment(this.dateRange.startDate).format('YYYY-MM-DD')
      // this.dateRange.endDate = moment(this.dateRange.endDate).format('YYYY-MM-DD')
    },
    dateChange() {
      this.trendlineModalDateRange.startDate = moment(this.date.startDate).subtract(1, 'weeks').format("YYYY-MM-DD")
      this.trendlineModalDateRange.endDate = moment(this.date.startDate).format("YYYY-MM-DD")
      this.formatDates();
      this.getSegmentListData();
      this.getTableData();
      this.getPinListData();
    },

    dateChangeTrendLineAndMap() {
      this.getPinListForTrendLine();
      this.getTrendlineGraphData();
      this.getStateWiseData();
      this.getPieChartData();
    },

    dateChangeModalTrendLine() {
      this.getPinListForModalTrendLine();
      this.getModalTrendlineGraphData();
    },

    getPieChartData() {
      let self = this;
      this.loader = true;
      this.viewTrendLineData = ''
      this.procesedPieChartData = []
      // this.loader = true;
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platform: this.selectedTrendLinePlatform.toLowerCase(),
      };
      if (this.selectedSegementForTrendline != 'all') {
        payload.segment = this.selectedSegementForTrendline
      }
      const url = "/api/v2/indian_clients/platform/availability";
      self.$http.post(url, payload).then(
        (res) => {
          let data = res.data.data
          if (data) {
            this.procesedPieChartData = [{
              name: 'Available',
              y: data.percentage_available,
              color: {
                linearGradient: {
                  x1: 0, y1: 0, x2: 1, y2: 1
                },
                stops: [
                  [0, 'rgba(1, 105, 92, 1)'],
                  [1, 'rgba(0, 150, 136, 1)']
                ]
              }
            },
            {
              name: 'Unavailable',
              y: data.percentage_non_available,
              color: "#d66772"
            }]

          }
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },

    getTrendlineGraphData() {
      let self = this;
      this.loader1 = true;
      this.viewTrendLineData = ''
      // this.loader = true;
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platform: [this.selectedTrendLinePlatform],
      };
      if (this.selectedSegementForTrendline != 'all') {
        payload.segment = this.selectedSegementForTrendline
      }
      if (this.selectedProductListForTrendline.length) {
        payload.product = this.selectedProductListForTrendline
      }
      if (this.selectedPinForTrendLine.length) {
        payload.pincode = this.selectedPinForTrendLine.map(data => data)
      }
      const url = "/api/v2/indian_clients/pincode/availability";
      self.$http.post(url, payload).then(
        (res) => {
          this.viewTrendLineData = res.data.data
          // window.location = response.body.data;
          this.processPincodeLevelTrendlineGraph();
          self.loader1 = false;
        },
        (err) => {
          self.loader1 = false;
          console.log("err");
        }
      );
    },

    getModalTrendlineGraphData() {
      let self = this;
      this.loader = true;
      this.viewModalTrendLineData = ''
      let payload = {
        start_date: moment(this.trendlineModalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.trendlineModalDateRange.endDate).format("YYYY-MM-DD"),
        platform: [this.selectedPlatformTrendlineModal],
      };
      if (this.selectedSegmentTrendlineModal != 'all') {
        payload.segment = this.selectedSegmentTrendlineModal
      }

      if (this.selectedProductTrendlineModal.length) {
        payload.product = [this.selectedProductTrendlineModal]
      }
      if (this.selectedPinTrendLineModal.length) {
        payload.pincode = this.selectedPinTrendLineModal.map(data => data)
      }
      const url = "/api/v2/indian_clients/pincode/availability";
      self.$http.post(url, payload).then(
        (res) => {
          this.viewModalTrendLineData = res.data.data
          // window.location = response.body.data;
          this.processPincodeLevelModalTrendlineGraph();
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },

    getStateWiseData() {
      let self = this;
      this.loader2 = true;
      this.procedIndiaMapData = []
      this.viewIndiaMapData = ''
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platform: [this.selectedTrendLinePlatform],
      };
      if (this.selectedSegementForTrendline != 'all') {
        payload.segment = this.selectedSegementForTrendline
      }
      if (this.selectedProductListForTrendline.length) {
        payload.product = this.selectedProductListForTrendline
      }
      const url = "/api/v2/indian_clients/state/availability";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          self.loader2 = false;
          this.viewIndiaMapData = response.body.data
          if (this.viewIndiaMapData.length)
            this.processIndiaMapData();
        },
        (err) => {
          self.loader2 = false;
          console.log("err");
        }
      );
    },

    getSegmentWiseProductListData() {
      let self = this;
      this.loader3 = true;
      let payload = {
        timestamp: moment(this.trendlineModalDateRange.endData).format("YYYY-MM-DD"),
        client: this.client,
      };
      const url = "/api/v2/indian_clients/segment/list";
      self.$http.post(url, {}).then(
        (response) => {
          this.viewSegmentPlatformAndProductData = response.data.data
          this.viewPlatformList = Object.keys(response.data.data)
          this.selectedTrendLinePlatform = this.viewPlatformList[0]
          this.tempSelectedTrendLinePlatform = this.viewPlatformList[0]
          this.processSegmentData();
          self.loader3 = false;
        },
        (err) => {
          self.loader3 = false;
          console.log("err");
        }
      );
    },

    processSegmentData() {
      this.viewSegmentData = Object.keys(this.viewSegmentPlatformAndProductData[this.selectedTrendLinePlatform])
      if (this.viewSegmentData.includes(this.selectedSegementForTrendline)) {
        this.selectedSegementForTrendline = this.selectedSegementForTrendline
      }
      else {
        this.selectedSegementForTrendline = 'all'
      }
      this.processProductListOfSegment();
    },

    processProductListOfSegment() {
      this.viewProductList = ''
      this.selectedProductListForTrendline = []
      if (this.selectedSegementForTrendline === 'all') {
        let temp = []
        for (let [segment, productName] of Object.entries(this.viewSegmentPlatformAndProductData[this.selectedTrendLinePlatform])) {
          temp = temp.concat(productName)
        }
        this.viewProductList = temp
      }
      else {
        this.viewProductList = this.viewSegmentPlatformAndProductData[this.selectedTrendLinePlatform][this.selectedSegementForTrendline]
      }
      // this.getPieChartData();
      this.getTrendlineGraphData();
      this.getStateWiseData();
      this.getPieChartData();
    },

    processSegmentModalData(isModal) {
      this.viewModalSegmentData = Object.keys(this.viewSegmentPlatformAndProductData[this.selectedPlatformTrendlineModal])
      if (this.viewModalSegmentData.includes(this.selectedSegementForTrendlineModal)) {
        this.selectedSegementForTrendlineModal = this.selectedSegementForTrendlineModal
      }
      else {
        this.selectedSegementForTrendlineModal = 'all'
      }
      this.processModalProductListOfSegment(isModal);
    },

    processModalProductListOfSegment(isModal) {
      this.viewModalProductList = ''
      if (isModal)
        this.selectedProductTrendlineModal = this.selectedProductTrendlineModal
      else
        this.selectedProductTrendlineModal = []

      if (this.selectedSegmentTrendlineModal === 'all') {
        let temp = []
        for (let [segment, productName] of Object.entries(this.viewSegmentPlatformAndProductData[this.selectedPlatformTrendlineModal])) {
          temp = temp.concat(productName)
        }
        this.viewModalProductList = temp
      }
      else {
        this.viewModalProductList = this.viewSegmentPlatformAndProductData[this.selectedPlatformTrendlineModal][this.selectedSegmentTrendlineModal]
      }
      // this.getPieChartData();
      this.getModalTrendlineGraphData();
    },

    changeProductName() {
      this.getTrendlineGraphData();
      this.getStateWiseData();
    },

    processIndiaMapData() {
      this.procedIndiaMapData = []
      for (let [key, stateName] of Object.entries(this.indiaStateMapper)) {
        let matchingState = this.viewIndiaMapData.find(stateData => stateData.state === stateName);
        if (matchingState) {
          if (matchingState.percentage_available >= 90) {
            this.procedIndiaMapData.push([key, matchingState.percentage_available, 'rgba(173, 247, 182, 1)'])
          }
          else if (matchingState.percentage_available < 90 && matchingState.percentage_available > 70) {
            this.procedIndiaMapData.push([key, matchingState.percentage_available, 'rgba(194, 195, 255, 1)'])
          }
          else if (matchingState.percentage_available <= 70 && matchingState.percentage_available > 20) {
            this.procedIndiaMapData.push([key, matchingState.percentage_available, 'rgba(255, 242, 194, 1)'])
          }
          else {
            this.procedIndiaMapData.push([key, matchingState.percentage_available, 'rgba(255, 211, 211, 1)'])
          }

        }
        else {
          this.procedIndiaMapData.push([key, 105, "#f0f0f0"])
        }
      }
    },

    processPincodeLevelTrendlineGraph() {
      this.procedTrandLineData = {}
      let seriesData = [{
        name: 'Availability %',
        color: "#47A694",
        tooltip: { valueSuffix: "%" },
        marker: {
          enabled: true,
          lineWidth: 2,
          fillColor: 'white',
          lineColor: '#46A493',
          radius: 5,
        },
        dataLabels: {
          enabled: true,
          allowOverlap: true,
          style: { fontWeight: 0 },
          formatter: function () {
            return this.point.y + "%";
          },
        },
        data: []
      }]
      let xAxisData = [];
      for (let data of this.viewTrendLineData) {
        xAxisData.push(moment(data.date).format("MMM DD, YY"));
        seriesData[0].data.push(data.percentage_available)
      }
      this.procedTrandLineData.id = 'pinLevelGraph'
      this.procedTrandLineData.xAxis = xAxisData;
      this.procedTrandLineData.seriesData = seriesData;
    },

    processTrendLineModal(platform, segment, productName) {
      this.showTrendLineModal = true;
      this.procedModalTrandLineData = { xAxis: [] };
      this.selectedPlatformTrendlineModal = platform;
      this.selectedSegmentTrendlineModal = segment;
      this.selectedProductTrendlineModal = productName;
      this.selectedPinTrendLineModal = this.locationDropdown.checkSelectedPins;
      this.processSegmentModalData(true);
      this.getPinListForModalTrendLine();
      // this.getModalTrendlineGraphData();
    },

    processModal(all_data, heading, check) {
      this.modalData.heading = heading;
      let modified_data = JSON.parse(JSON.stringify(all_data));
      modified_data = modified_data.filter((location) => {
        location.data = location.data.filter(
          (pincode_data) => pincode_data.available == check
        );
        if (location.data.length) return true;
        else return false;
      });
      this.modalData.tableData = modified_data;
      this.showModal = true;
    },

    processPincodeLevelModalTrendlineGraph() {
      this.procedModalTrandLineData = {}
      let seriesData = [{
        name: 'Availability %',
        color: "#47A694",
        tooltip: { enabled: false, valueSuffix: "%" },
        marker: {
          enabled: true,
          lineWidth: 2,
          fillColor: 'white',
          lineColor: '#46A493',
          radius: 5,
        },
        dataLabels: {
          enabled: true,
          allowOverlap: true,
          style: { fontWeight: 0 },
          formatter: function () {
            return this.point.y + "%";
          },
        },
        data: []
      }]

      let xAxisData = [];
      for (let data of this.viewModalTrendLineData) {
        xAxisData.push(moment(data.date).format("MMM DD, YY"));
        seriesData[0].data.push(data.percentage_available)
      }
      this.procedModalTrandLineData.id = 'pinLevelModalGraph'
      this.procedModalTrandLineData.xAxis = xAxisData;
      this.procedModalTrandLineData.seriesData = seriesData
    },

    getSegmentListData() {
      let self = this;
      this.loader4 = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
      };
      const url = "/api/v2/india_clients/pincode_category";
      self.$http.post(url, payload).then(
        (response) => {
          self.segmentDropdown.options = response.data.data.data
          self.segmentDropdown.productList = response.data.data.products_name
          this.filterProcutListForAvailMetricTable(false);
          self.segmentDropdown.isSegment = response.data.data.is_segment
          self.loader4 = false;
        },
        (err) => {
          self.loader4 = false;
          console.log("err");
        }
      );
    },

    filterProcutListForAvailMetricTable(isTable) {
      // console.log("check the data", this.segmentDropdown.productList)
      this.segmentDropdown.productFilterList = []
      if (this.segmentDropdown.selectedSegment != '' && isTable) {
        this.segmentDropdown.selectedProduct = ''
      }
      if (this.segmentDropdown.selectedSegment == '') {
        for (let [segment, segmentData] of Object.entries(this.segmentDropdown.productList)) {
          segmentData.forEach(productName => {
            this.segmentDropdown.productFilterList.push(productName)
          })
          // this.segmentDropdown.productFilterList.push.apply(this.segmentDropdown.productFilterList,segmentData)
        }
      }
      else {
        this.segmentDropdown.productFilterList = this.segmentDropdown.productList[this.segmentDropdown.selectedSegment]
      }
      console.log("chcke thr final", this.segmentDropdown.productFilterList)

    },
    getPinListForTrendLine() {
      let self = this;
      this.loader5 = true;
      let payload = {
        timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
      };
      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.viewPinListTrendLine = response.data.data
          self.loader5 = false;
        },
        (err) => {
          self.loader5 = false;
          console.log("err");
        }
      );
    },

    getPinListForModalTrendLine() {
      let self = this;
      this.loader6 = true;
      let payload = {
        timestamp: moment(this.trendlineModalDateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
      };
      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.viewPinListModalTrendLine = response.data.data
          self.loader6 = false;
        },
        (err) => {
          self.loader6 = false;
          console.log("err");
        }
      );
    },

    getPinListData() {
      let self = this;
      // this.loader7 = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
      };
      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.locationDropdown.options = response.data.data
          // this.locationDropdown = response.data.data
          // self.loader7 = false;
        },
        (err) => {
          // self.loader7 = false;
          console.log("err");
        }
      );
    },

    getTableData() {
      this.loader8 = true;
      this.mainTableData.data = []
      const url = "/api/v2/india_clients/pincode_product";
      const payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
        pincode: this.locationDropdown.selectedPin,
      };
      if (this.segmentDropdown.selectedProduct != '') {
        payload.product_name = this.segmentDropdown.selectedProduct
      }
      if (this.segmentDropdown.isSegment) {
        payload.segment = this.segmentDropdown.selectedSegment == "" ? [] : [this.segmentDropdown.selectedSegment]
      }

      this.$http
        .post(url, payload)
        .then((Response) => {
          const resData = Response.data.data;
          const modifiedTableData = resData.data;
          const headerData = resData.headers;
          this.mainTableData.header = [];
          this.mainTableData.data = modifiedTableData;

          headerData.forEach((data) => {
            console.log("check the data", data);
            if (data.label == "Product Name")
              this.mainTableData.header.unshift({
                key: "product_name",
                value: data.label,
                img: data.img_url
              });
            else this.mainTableData.header.push({ key: data.key, value: data.label, img: data.img_url });
          });
          this.$nextTick(() => {
            this.dataTable();
          })
          this.loader8 = false;
        })
        .catch((err) => {
          this.loader8 = false;
          console.log(err);
        });
    },

    dataTable() {
      $('#indiagate-dashboard-table').DataTable({

        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search..."
        },
        // dom: '<"top">frt<"bottom"l>p<"clear">',
        pagingType: "full_numbers",
        searching: true,
        order: [],
        // sorting: [[1, 'asc']],
        autoWidth: false,
      })
      $('#indiagate-dashboard-table').wrap("<div style='overflow:auto; width:100%; position:relative;'></div>");

      $('#indiagate-dashboard-table').css('min-width', '1000px');
      let search = require("../../../public/Icons_SVG/Search.svg");
      $("#indiagate-dashboard-table" + "_filter > label").append(`<div><img src='${search}' /></div>`);

    },
    processSelectedPin() {
      if (this.locationDropdown.checkSelectedPins) {
        this.locationDropdown.selectedPin = this.locationDropdown.checkSelectedPins.map(
          (obj) => obj
        );
        this.getSegmentListData();
        this.getTableData();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
#dashboard {
  font-family: "Poppins", sans-serif !important;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 6px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}

.CustomDropdown {
  border: 1px solid rgb(172, 172, 172);
  z-index: 999999999 !important;
  margin-left: 5px;
  border-radius: 3px;
  margin-top: 2px;
  position: absolute;
  background: white;
  width: 200px;
  right: 12px;
}

.customItem {
  padding: 3px 5px 2px 8px;
  cursor: pointer;
  color: var(--primary_brand)
}


.customItem:hover {
  background: var(--primary_brand-10);
}

.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin: 10px;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.avail_modal_cta {
  color: #000;
  text-decoration: none;
  background-color: transparent;
}

.unavail_modal_cta {
  color: black;
  text-decoration: none;
  background-color: transparent;
}

.unavail_modal_cta:hover {
  text-decoration: underline;
  cursor: pointer;
}

.avail_modal_cta:hover {
  text-decoration: underline;
  cursor: pointer;
}

.info_mrp {
  text-align: start;
  padding-left: 5px;
  color: var(--primary_brand);
  font-weight: 500;
  font-size: 12px;
}

.info_price {
  text-align: start;
  padding-left: 5px;
  color: var(--primary_brand);
  font-weight: 500;
  font-size: 12px;
}

.icon {
  font-size: 15px;
  color: var(--primary_brand);
  /* z-index: 1000; */
}

.icon:hover {
  cursor: pointer !important;
}

.icon_container {
  /* display: flex; */
  /* justify-content: end; */
  /* min-width: 140px; */
  /* margin-bottom: -20px; */
}


tr:not(:last-child)>td {
  border-bottom: 1px solid var(--base_color-20) !important;
}

tr:first-child>td {
  border-top: 1px solid var(--base_color-20) !important;
}

table {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
}

th:not(:last-child),
td:not(:last-child) {
  border-right: var(--border) !important;
}

td {
  vertical-align: top !important;
  padding: 0px !important;
  font-size: 13px !important;
  font-family: poppins !important;
}

/* td:not(:first-child){
  width: 350px !important;
} */
td:first-child {
  background-color: white;
  vertical-align: middle !important;
  padding-left: 10px !important;
  text-align: left;
  max-width: 140px;
}

#indiagate-dashboard-table td:nth-child(2) {
  width: 250px;
  text-align: center;
}

td {
  background-color: white;
  vertical-align: middle !important;
  text-align: left;
  max-width: 140px;
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 10px 0px !important;
}
</style>

<style>
.customModal {
  z-index: 999 !important;
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
  width: 100%;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  font-family: "poppins";
  border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
</style>

<style>
.vue-treeselect__control {
  height: 35px !important;
  border: 1px solid rgba(75, 75, 75, 0.4) !important;
  border-radius: 5px !important;
}

.vue-treeselect__multi-value {
  height: 30px !important;
  overflow: auto !important;
}

.vue-treeselect__multi-value-item {
  background-color: rgba(6, 85, 89, 1) !important;
  color: white !important;
}

.vue-treeselect__value-remove {
  color: white !important;
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  font-family: "poppins";
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}

.lineBetween {
  padding-top: 10px !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

@media only screen and (max-width: 1700px) {
  .primarycolor {
    padding: 5px 10px !important;
  }

  .custom_dropdown {}
}

#indiagate-dashboard-table_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#indiagate-dashboard-table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#indiagate-dashboard-table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#indiagate-dashboard-table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#indiagate-dashboard-table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#indiagate-dashboard-table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#indiagate-dashboard-table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#indiagate-dashboard-table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#indiagate-dashboard-table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#indiagate-dashboard-table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#indiagate-dashboard-table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

#indiagate-dashboard-table_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#indiagate-dashboard-table_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}


#indiagate-dashboard-table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#indiagate-dashboard-table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#indiagate-dashboard-table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#indiagate-dashboard-table {
  border-radius: 20px 20px 0 0;
}

#indiagate-dashboard-table .thead-normal,
#indiagate-dashboard-table .thead-normal tr:first-child,
#indiagate-dashboard-table .thead-normal>tr:first-child>th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#indiagate-dashboard-table .thead-normal>tr:first-child>th:last-child {
  border-radius: 0 21px 0 0;
}

table.dataTable th {
  background-color: rgba(39, 86, 89, 0.1) !important;
  color: black !important;
}

#indiagate-dashboard-table .thead-normal>tr:first-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#indiagate-dashboard-table .thead-normal>tr:last-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
}

#indiagate-dashboard-table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#indiagate-dashboard-table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#indiagate-dashboard-table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#indiagate-dashboard-table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#indiagate-dashboard-table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}



/* #indiagate-dashboard-table_wrapper .bottom {
  margin-bottom: -30px;
} */
#indiagate-dashboard-table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#indiagate-dashboard-table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#indiagate-dashboard-table .thead-normal>tr>th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#indiagate-dashboard-table .thead-normal>tr>th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#indiagate-dashboard-table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#indiagate-dashboard-table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#indiagate-dashboard-table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#indiagate-dashboard-table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#trendLineModal .modal-header {
  text-transform: capitalize;
}

#trendLineModal .modal-content {
  width: 107% !important;
}



@media screen and (max-width: 767px) {
  #indiagate-dashboard-table_paginate {
    float: none;
    width: auto;
  }
}
</style>
